// extracted by mini-css-extract-plugin
export var cardContainer = "_nv-0";
export var cardHeader = "_nv-2";
export var collapsedState = "_nv-3";
export var dragHandle = "_nv-5";
export var dragHandleIcon = "_nv-6";
export var dragging = "_nv-1";
export var titleArea = "_nv-4";